<template>
	<div class="nav-class" :style="dataStyle">
		<div class="nav-cont">
			<div class="iconfont icon-fanhui1" @click="goBack"></div>
			<div class="tit">{{dataTit}}</div>
			<div v-if="dataBonts.length <= 0" class="no-list"></div>
			<ul class="bonts-ul" v-else>
				<li class="bonts-ul-li" @click="goB(item)" v-for="(item, index) in dataBonts" :key="index">{{item}}</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
			}
		},
		props: {
			dataTit: {
				type: String,
				default: ''
			},
			dataStyle: {
				type: String,
				default: ''
			},
			dataBonts: {
				type: Array,
				default () {
					return []
				}
			}
		},
		mounted () {
		},
		methods: {
			goBack () {
              this.$router.go(-1)
			},
			goB (i) {
				this.$emit('gobont', i)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.nav-class{
		background-color: #FFFFFF;
		position: fixed;
		left: 0;
		right: 0;
		z-index: 13;
		.nav-cont{
			padding: 10px 10px 5px 10px;
			display: flex;
			justify-content: space-between;
			color: #000000;
			height: 32px;
			.tit{
				font-size: 17px;
				text-align: center;
				line-height: 34px;
			}
			.icon-fanhui1{
				font-size: 16px;
				width: 54px;
				line-height: 32px;
			}
			.bonts-ul{
				display: flex;
				justify-content: flex-end;
				font-size: 15px;
				color: #FFFFFF;
				.bonts-ul-li{
					border-radius: 15px;
					padding: 4px 12px;
					margin-left: 10px;
					background-color: #ffc225;
				}
				.bonts-ul-li:nth-of-type(1){
					margin-left: 0
				}
			}
		}
	}
	.no-list{
		width: 54px;
	}
</style>



// WEBPACK FOOTER //
// src/components/public/navBack.vue